export const firebaseConfig = {
    apiKey: "AIzaSyBUvRZ5gz5y0Tqk9qvUINYnS2Ht-epqnfE",
    authDomain: "livelocal-consumer-app.firebaseapp.com",
    projectId: "livelocal-consumer-app",
    storageBucket: "livelocal-consumer-app.appspot.com",
    messagingSenderId: "643773834344",
    appId: "1:643773834344:web:c5c3b850104c686cda07dd",
    measurementId: "G-6VDWR0PVDG"
  };